import { useEffect, type RefObject } from 'react';

/**
 * Настоящая высота липкой шапки: ряд 60px, вырез сверху на iOS и полоса "Нет подключения", пока
 * она на экране. Полоса разворачивается плавно и может переноситься в две строки, поэтому высоту
 * не посчитать заранее - шапка меряет себя сама (`useHeaderHeightVar`) и пишет её в переменную на
 * `<html>`.
 */
export const HEADER_HEIGHT_VAR = '--app-header-height';

/**
 * Высота шапки для `scroll-margin-top` и похожих отступов. Пока шапка не измерена (сервер,
 * первый кадр) - её ряд и вырез: полосы в этот момент ещё нет.
 */
export const HEADER_HEIGHT = `var(${HEADER_HEIGHT_VAR}, calc(60px + env(safe-area-inset-top, 0px)))`;

/** Держит `HEADER_HEIGHT_VAR` равной высоте элемента шапки. */
export const useHeaderHeightVar = (ref: RefObject<HTMLElement | null>): void => {
  useEffect(() => {
    const node = ref.current;
    if (!node || typeof ResizeObserver === 'undefined') {
      return;
    }
    const root = document.documentElement;
    let written = -1;
    const update = () => {
      const height = Math.ceil(node.getBoundingClientRect().height);
      // Во время разворота полосы наблюдатель зовёт на каждом кадре; переменная на `<html>`
      // пересчитывает стили всей страницы, поэтому пишем только новое значение.
      if (height !== written) {
        written = height;
        root.style.setProperty(HEADER_HEIGHT_VAR, `${height}px`);
      }
    };
    const observer = new ResizeObserver(update);
    observer.observe(node);
    update();

    return () => {
      observer.disconnect();
      root.style.removeProperty(HEADER_HEIGHT_VAR);
    };
  }, [ref]);
};
